var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFacebook1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5999 12.0779C21.5996 10.2433 21.0737 8.44727 20.0844 6.90235C19.095 5.35742 17.6838 4.12831 16.0176 3.36054C14.3514 2.59276 12.5002 2.31847 10.683 2.57013C8.86578 2.82179 7.15874 3.58887 5.76395 4.78055C4.36915 5.97223 3.34502 7.53861 2.81279 9.29426C2.28055 11.0499 2.26251 12.9213 2.7608 14.6869C3.25909 16.4524 4.25283 18.0383 5.62439 19.2566C6.99595 20.475 8.68789 21.2748 10.4999 21.5615L10.4999 14.8529H8.0627V12.0779H10.4999V9.96286C10.4999 7.55686 11.9333 6.22786 14.1257 6.22786C14.8457 6.23785 15.564 6.30042 16.2749 6.41506V8.77786H15.0641C14.8578 8.75046 14.6479 8.76984 14.4501 8.83456C14.2523 8.89929 14.0716 9.0077 13.9213 9.15176C13.7711 9.29582 13.6552 9.47184 13.5823 9.66678C13.5093 9.86172 13.4812 10.0706 13.4999 10.2779V12.0779H16.1627L15.7367 14.8529H13.4999L13.4999 21.5615C15.7582 21.2042 17.8148 20.0527 19.2997 18.3142C20.7846 16.5756 21.6003 14.3642 21.5999 12.0779Z",
    fill: "#2E6FE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFacebook1);
export default __webpack_public_path__ + "static/media/logo-facebook-1.0084b5dc7ed655532d98d46f9da44af6.svg";
export { ForwardRef as ReactComponent };